const DropDown = ({entity, fld}) => {
    const defaultChangeHandler = (event) => {
        const newVal = event.target.value
        // console.log(entity.id)
        if(!!fld.changeHandler) {
            fld.changeHandler(entity.id, fld.name, newVal)
        } else {
            console.log("defaultChangeHandler", fld.name, newVal)
        }
    }
    return (
        <select
            value={entity[fld.name]}
            onChange={defaultChangeHandler}
        >
            <option value=""></option>
            {fld.options.map(([val, lab]) =>
                <option key={val} value={val}>{lab}</option>
            )}
        </select>
    )
}

export default DropDown